<template>
  <details-header :loading="loading" dense hide-avatar>
    <template v-slot:headerLine1>
      <span class="secondarytext--text">Feature Hub</span>
    </template>
    <template v-slot:tabs>
      <v-tabs>
        <v-tab v-if="settings.isPulseActive" to="/features/tracking">
          Tracking
        </v-tab>
        <v-tab v-if="settings.isSurveysActive" to="/features/surveys">
          Surveys
        </v-tab>
        <v-tab v-if="settings.isRecognitionActive" to="/features/recognition">
          Recognition
        </v-tab>
        <v-tab v-if="settings.isResourcesActive" to="/features/training">
          Training
        </v-tab>
        <v-tab v-if="settings.isReviewActive" to="/features/review">
          360 Review
        </v-tab>
        <v-tab v-if="settings.isCheckInActive" to="/features/meetings">
          Meetings
        </v-tab>
        <v-tab v-if="settings.isCheckInActive" to="/features/actionitems">
          Action Items
        </v-tab>
        <v-tab v-if="settings.isGoalsActive" to="/features/goals">
          Goals
        </v-tab>
        <v-tab
          v-if="settings.isAnnualReviewActive"
          to="/features/annual-reviews"
        >
          Annual Review
        </v-tab>
      </v-tabs>
    </template>
    <v-row v-if="!_.isEmpty(profile)">
      <v-col cols="12">
        <pulse-overview v-if="tab == 'tracking'"></pulse-overview>
        <template v-if="tab == 'surveys'">
          <survey-list
            :initialFilter="initialFilter"
            v-if="isAdminOrManager"
          ></survey-list>
          <survey-queue v-else></survey-queue>
        </template>
        <template v-if="tab == 'training'">
          <resource-list
            :initialFilter="initialFilter"
            v-if="isAdminOrManager"
          ></resource-list>
          <resource-queue v-else></resource-queue>
        </template>
        <recognition-list v-if="tab == 'recognition'"></recognition-list>
        <check-in-list v-if="tab == 'meetings'"></check-in-list>
        <outstanding-action-item-list
          v-if="tab == 'actionitems'"
        ></outstanding-action-item-list>
        <goals
          v-if="tab == 'goals'"
          :user="profile"
          showDetailHeader
          getData
          :filter="filter"
        ></goals>
        <review-overview v-if="tab == 'review'"></review-overview>
        <annual-review-overview v-if="tab == 'annual-reviews'">
        </annual-review-overview>
      </v-col>
    </v-row>
  </details-header>
</template>

<script>
import { mapGetters } from "vuex";
import DetailsHeader from "@/components/common/DetailsHeader";
import SurveyList from "@/components/surveys/SurveyList";
import ResourceList from "@/components/resources/ResourceList";
import SurveyQueue from "@/components/surveys/SurveyQueue";
import ResourceQueue from "@/components/resources/ResourceQueue";
import RecognitionList from "@/components/recognition/RecognitionList";
import PulseOverview from "@/components/pulse/PulseOverview";
import CheckInList from "@/components/checkin/CheckInList";
import Goals from "@/components/goals/Goals";
import ReviewOverview from "@/components/reviews/ReviewOverview";
import AnnualReviewOverview from "@/components/annualreviews/AnnualReviewOverview";
import OutstandingActionItemList from "@/components/checkin/OutstandingActionItemList";
import moment from "moment";
export default {
  name: "FeatureDashboard",
  components: {
    DetailsHeader,
    SurveyList,
    ResourceList,
    ResourceQueue,
    SurveyQueue,
    RecognitionList,
    PulseOverview,
    CheckInList,
    Goals,
    ReviewOverview,
    OutstandingActionItemList,
    AnnualReviewOverview
  },
  data: () => ({
    tab: null,
    loading: false,
    initialFilter: null,
    filter: null
  }),
  computed: {
    isAdminOrManager() {
      return this.is_admin || this.is_manager;
    },
    ...mapGetters({
      profile: "profile/profile",
      settings: "profile/settings",
      is_admin: "profile/is_admin",
      is_manager: "profile/is_manager"
    })
  },
  watch: {
    settings(val, oldVal) {
      if (val != oldVal) {
        this.updateTab();
      }
    },
    profile(val, oldVal) {
      if (val != oldVal) {
        this.updateTab();
        this.filter.userId = this.profile.id;
      }
    },
    tab(val, oldVal) {
      if (val == oldVal) {
        return;
      }

      if (val == "tracking" && !this.settings.isPulseActive) {
        this.tab = "surveys";
        return;
      }
      if (val == "surveys" && !this.settings.isSurveysActive) {
        this.tab = "recognition";
        return;
      }
      if (val == "recognition" && !this.settings.isRecognitionActive) {
        this.tab = "training";
        return;
      }
      if (val == "training" && !this.settings.isResourcesActive) {
        this.tab = "tracking";
        return;
      }
      if (val == "review" && !this.settings.isReviewActive) {
        this.tab = "meetings";
        return;
      }
      if (val == "meetings" && !this.settings.isCheckInActive) {
        this.tab = "actionitems";
        return;
      }
      if (val == "actionitems" && !this.settings.isCheckInActive) {
        this.tab = "goals";
        return;
      }
      if (val == "goals" && !this.settings.isGoalsActive) {
        this.tab = "annual-reviews";
        return;
      }
      if (val == "annual-reviews" && !this.settings.isAnnualReviewActive) {
        this.tab = "review";
        return;
      }
    }
  },
  created() {
    this.filter = {
      timeframeId: this.$enums.timeframes.LAST_90_DAYS,
      customStartDate: null,
      customEndDate: null,
      customTimezone: moment.tz.guess(true),
      userId: this.profile.id
    };
    this.updateTab();
  },
  methods: {
    updateTab() {
      if (this._.isEmpty(this.settings) || this._.isEmpty(this.profile)) {
        return;
      }
      this.tab = this.$route.params.tab;
      switch (this.$route.params.tab) {
        case "surveys":
          if (this.$route.params.id) {
            this.initialFilter = {
              surveyId: this.$route.params.id,
              id: this.$route.params.instanceId,
              teamId: this.$route.query.teamId,
              memberId: this.$route.query.memberId
            };
          }
          break;
      }
    }
  }
};
</script>
